
import {
  getAlarmSetPage,
  getAlarmSetDel,
  updateFaultCode
} from "@/api/api-basic";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import addFile from "./components/add-file.vue";
import updataFile from "./components/updata-file.vue";
import allConfig from "./components/all-config.vue";
import { getOptionList, optionKey } from "@/api/api-dict";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-add-file": addFile,
    "pi-updata-file": updataFile,
    "pi-all-config": allConfig
  }
})
export default class PiAlarmSet extends Vue {
  private formInline: objAny = {
    entSubUser: true,
    globalOrder: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: "",
    logined: true
  };

  private gradeList: object[] = [];
  private typeList: object[] = [];
  private privilegeVoObj: objAny = {};
  private fileStatusColor: objAny = {
    "1": "primary",
    "2": "default",
    "3": ""
  };
  private loading = false;
  private total = 0;

  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("alarmSet.faultName"),
      key: "faultName",
      slot: "faultName",
      minWidth: 120
    },
    {
      title: i18n.t("alarmSet.faultCode"),
      key: "faultCode",
      minWidth: 120
    },
    {
      title: i18n.t("alarmSet.faultTipMsg"),
      key: "faultTipMsg",
      slot: "faultTipMsg",
      minWidth: 100
    },
    {
      title: i18n.t("alarmSet.alarmLevel"),
      slot: "grade",
      minWidth: 100
    },
    {
      title: i18n.t("alarmSet.alarmType"),
      slot: "type",
      minWidth: 100
    },
    // {
    //   title: "是否删除",
    //   key: "flag",
    //   minWidth: 120,
    //   slot: "flag"
    // },
    {
      title: i18n.t("operation"),
      key: "action",
      minWidth: 120,
      slot: "action"
    }
  ];
  public queryClick() {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public tableChange(val: number) {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getAlarmSetPage(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      ret.data.map((item: objAny) => {
        item.alarmLevel = item.alarmLevel + "";
        item.alarmType = item.alarmType + "";
      });
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  public addClick(): void {
    const addFile: objAny = this.$refs["addFile"];
    addFile.open();
  }
  public addConfig() {
    const allConfig: objAny = this.$refs["allConfig"];
    allConfig.open();
  }

  public editClick(item: objAny) {
    const updataFile: objAny = this.$refs["updataFile"];
    updataFile.open(item);
  }
  async delItemClick(item: objAny): Promise<void> {
    const ret = await getAlarmSetDel({
      faultCode: item.faultCode
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }
  async updateFaultCode(item: objAny) {
    const ret = await updateFaultCode({
      faultCode: item.faultCode,
      faultName: item.faultName,
      faultEnName: item.faultEnName || "-",
      faultTipMsg: item.faultTipMsg,
      faultTipEnMsg: item.faultTipEnMsg || "-",
      solution: item.solution,
      alarmLevel: item.alarmLevel,
      alarmType: item.alarmType
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("updateSuccess"));
      this.getTableList();
    }
  }
  async getOptionList() {
    const ret = await getOptionList(
      [optionKey.alarmLevelObj, optionKey.alarmTypeObj]
      // "number"
    ); //请求字典
    this.gradeList = ret[optionKey.alarmLevelObj];
    this.typeList = ret[optionKey.alarmTypeObj];
  }
  public selectChange(row: objAny, index: number) {
    this.$set(this.tableList, index, row);
  }

  mounted() {
    this.privilegeVoObj = this.$route.meta.privilegeVoObj;
    this.getOptionList();
    this.getTableList();
  }
}
